import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List } from 'immutable'
import isEqual from 'lodash/isEqual'
import { formatMessage } from 'lib/intl'
import SelectList from 'components/common/SelectList'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import ArrayHelper from 'helpers/array'

class FilterUnitGroup extends Component {
  onChange = values => {
    const { activeUnitGroups, setMyJobsDataViewerFilter } = this.props
    const locusGroups = ArrayHelper.getArrData(values, [])

    if (!isEqual(locusGroups, activeUnitGroups.toArray())) {
      setMyJobsDataViewerFilter({ locusGroups })
    }
  }

  render() {
    const { activeUnitGroups, unitGroupList } = this.props
    const values = ArrayHelper.getValues(activeUnitGroups, unitGroupList)

    return (
      <SelectList
        multiple
        withCheckBox
        hasAllValueOption
        outMultipleValues={{
          all: [],
          empty: [-1],
        }}
        variant="outlined"
        name="unit_groups"
        label={formatMessage('unit_groups')}
        list={unitGroupList}
        value={values}
        onClose={this.onChange}
        map={{
          index: 'id',
          text: 'name',
        }}
      />
    )
  }
}

FilterUnitGroup.defaultProps = {
  activeUnitGroups: List([]),
  unitGroupList: List([]),
}

FilterUnitGroup.propTypes = {
  activeUnitGroups: PropTypes.instanceOf(List),
  unitGroupList: PropTypes.instanceOf(List),
  setMyJobsDataViewerFilter: PropTypes.func.isRequired,
}

export default connect(
  store => ({
    activeUnitGroups: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'locusGroups',
    ]),
    unitGroupList: store.getIn(['myJobsDataViewer', 'filters', 'unitGroups']),
  }),
  {
    setMyJobsDataViewerFilter,
  },
)(FilterUnitGroup)
